/* === ODUREE CUSTOM JAVASCRIPT === */

// Voeg hier custom functionaliteit toe
// Gebruik ES module imports van het thema waar mogelijk:
// import { ComponentName } from "theme";

function odureeTranslate(path, fallback) {
  if (typeof window.odureeT === "function") return window.odureeT(path, fallback);
  return fallback || "";
}

/* === ODUREE COUNTDOWN TIMER === */

(function () {
  const countdownEl = document.querySelector(".oduree-sotw__countdown");
  if (!countdownEl) return;

  const endDate = new Date(countdownEl.dataset.endDate).getTime();
  const daysEl = countdownEl.querySelector("[data-countdown-days]");
  const hoursEl = countdownEl.querySelector("[data-countdown-hours]");
  const minutesEl = countdownEl.querySelector("[data-countdown-minutes]");
  const secondsEl = countdownEl.querySelector("[data-countdown-seconds]");

  function updateCountdown() {
    const now = new Date().getTime();
    const diff = endDate - now;

    if (diff <= 0) {
      daysEl.textContent = "0";
      hoursEl.textContent = "0";
      minutesEl.textContent = "0";
      secondsEl.textContent = "0";
      return;
    }

    const days = Math.floor(diff / (1000 * 60 * 60 * 24));
    const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((diff % (1000 * 60)) / 1000);

    daysEl.textContent = days;
    hoursEl.textContent = hours;
    minutesEl.textContent = minutes;
    secondsEl.textContent = seconds;
  }

  updateCountdown();
  setInterval(updateCountdown, 1000);
})();

/* === ODUREE ADD TO CART (AJAX) === */

(function () {
  const form = document.querySelector(".oduree-sotw__form");
  if (!form) return;

  form.addEventListener("submit", function (e) {
    e.preventDefault();

    const button = form.querySelector("[data-add-to-cart]");
    const originalText = button.textContent;
    button.textContent = odureeTranslate("global.loading", "Loading") + "...";
    button.disabled = true;

    const formData = new FormData(form);
    const data = {
      id: formData.get("id"),
      quantity: formData.get("quantity"),
    };

    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then(function (response) {
        // Shopify geeft 422 terug bij uitverkocht / inventory_policy=deny.
        // Zonder deze check zou de knop ten onrechte "Toegevoegd ✓" tonen.
        if (!response.ok) {
          return response.json().then(function (err) {
            var msg = odureeTranslate("global.soldOut", "Sold out");
            if (err && err.status !== 422) msg = odureeTranslate("global.genericError", "Please try again");
            var e = new Error(msg);
            e.userMessage = msg;
            throw e;
          });
        }
        return response.json();
      })
      .then(function () {
        button.textContent = odureeTranslate("global.addedSuccess", "Added ✓");
        setTimeout(function () {
          button.textContent = originalText;
          button.disabled = false;
        }, 2000);

        // Update cart count in header
        (window.OdureeCart && typeof window.OdureeCart.get === "function" ? window.OdureeCart.get() : fetch("/cart.js").then(function (r) { return r.json(); }))
          .then(function (cart) {
            var countEls = document.querySelectorAll(
              ".header__cart-count, [data-cart-count]",
            );
            countEls.forEach(function (el) {
              el.textContent = cart.item_count;
            });
          });
      })
      .catch(function (err) {
        button.textContent = (err && err.userMessage) || odureeTranslate("global.genericError", "Please try again");
        setTimeout(function () {
          button.textContent = originalText;
          button.disabled = false;
        }, 2500);
      });
  });
})();

/* === ODUREE QUICK-ADD (globale delegatie voor product cards) ===
   Handelt alle forms met [data-oduree-quick-add] af via AJAX.
   Flow: klik → .is-loading (spinner) → .is-success (check) → default (plus).
   Dispatcht cart:refresh + cart:open zodat de nieuwe CartDrawer opent. */
(function () {
  document.addEventListener("submit", async function (e) {
    const form = e.target.closest("[data-oduree-quick-add]");
    if (!form) return;
    e.preventDefault();
    e.stopPropagation();

    const btn = form.querySelector("button[type='submit']");
    if (!btn) return;

    btn.disabled = true;
    btn.classList.remove("is-success");
    btn.classList.add("is-loading");

    try {
      const res = await fetch("/cart/add.js", {
        method: "POST",
        body: new FormData(form),
        headers: {
          "X-Requested-With": "XMLHttpRequest",
          Accept: "application/json",
        },
      });
      if (!res.ok) throw new Error("Could not add product");

      // Events voor onze cart-drawer + andere listeners
      document.dispatchEvent(
        new CustomEvent("cart:refresh", { bubbles: true }),
      );
      document.dispatchEvent(new CustomEvent("cart:update", { bubbles: true }));
      document.dispatchEvent(new CustomEvent("cart:open", { bubbles: true }));

      // State-switch: loading → success
      btn.classList.remove("is-loading");
      btn.classList.add("is-success");

      // Na 1.5s terug naar plus
      setTimeout(function () {
        btn.classList.remove("is-success");
        btn.disabled = false;
      }, 1500);
    } catch (err) {
      console.error("Quick-add failed:", err);
      btn.classList.remove("is-loading");
      btn.disabled = false;
    }
  });
})();

/* === ODUREE SHIPPING-PROTECTION CLEANUP ===
   "Verzekerde Verzending" is een checkout-only fee die door de
   checkout-extension wordt toegevoegd. Als de bezoeker vanuit de
   checkout terug navigeert naar de storefront, blijft de line in
   de cart staan — dat mag niet. Dit script draait op elke
   storefront-pagina en strip alle lines met handle
   'verzekerde-verzending' uit de cart via /cart/change.js.
   Veilig: beïnvloedt de checkout-sessie niet (die draait op
   checkout.shopify.com, een ander domein). */
(function () {
  var HIDDEN_HANDLE = "verzekerde-verzending";
  // Op oduree.com is de handle vertaald (insured-shipping); het product-id is overal gelijk.
  var HIDDEN_PRODUCT_ID = 8880468361562;

  async function cleanupProtectionLines() {
    try {
      var cart = await (window.OdureeCart && typeof window.OdureeCart.get === "function"
        ? window.OdureeCart.get()
        : fetch("/cart.js", { cache: "no-store" }).then(function (r) { return r.json(); }));
      if (!cart || !Array.isArray(cart.items) || cart.items.length === 0) return;

      var toRemove = cart.items.filter(function (i) {
        return i && (i.product_id === HIDDEN_PRODUCT_ID || i.handle === HIDDEN_HANDLE);
      });
      if (toRemove.length === 0) return;

      // Verwijder alle matching lines via line-key (unique) met quantity: 0.
      // Seriëel om race-conditions te voorkomen (Shopify cart is single-writer).
      for (var idx = 0; idx < toRemove.length; idx++) {
        await fetch("/cart/change.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ id: toRemove[idx].key, quantity: 0 }),
        });
      }

      // Event voor cart-drawer / header-bubble refresh.
      document.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true }));
      document.dispatchEvent(new CustomEvent("cart:update", { bubbles: true }));
    } catch (err) {
      // Stil falen — niet blokkeren voor andere site-functies.
      if (window.console && console.warn) {
        console.warn("[Oduree] shipping-protection cleanup failed:", err);
      }
    }
  }

  // Eerste run zo vroeg mogelijk (direct bij script-load met defer).
  cleanupProtectionLines();

  // Tweede run wanneer bezoeker terugkomt op pagina uit bfcache (back-forward cache),
  // bijv. na de checkout via browser-back-knop.
  window.addEventListener("pageshow", function (event) {
    if (event.persisted) cleanupProtectionLines();
  });

  // Derde run wanneer tab weer zichtbaar wordt (bezoeker keert terug vanaf checkout-tab).
  document.addEventListener("visibilitychange", function () {
    if (document.visibilityState === "visible") cleanupProtectionLines();
  });
})();

/* === ODUREE APS5 STANDALONE CLEANUP ===
   APS5 Sample variants under `autoparfum-spray` are not sold as loose
   products. They may only exist as the dedicated Discovery Set product
   (`discovery-set-autoparfum-spray`), which uses its own variant IDs. */
(function () {
  var APS5_SAMPLE_VARIANT_IDS = [
    "53720783290714",
    "53720783323482",
    "53720783356250",
    "53720783389018",
    "53720783421786",
  ];

  var cleanupInProgress = false;

  async function cleanupStandaloneAps5Lines() {
    if (cleanupInProgress) return;
    cleanupInProgress = true;

    try {
      var cart = await (window.OdureeCart && typeof window.OdureeCart.get === "function"
        ? window.OdureeCart.get()
        : fetch("/cart.js", { cache: "no-store" }).then(function (r) { return r.json(); }));
      if (!cart || !Array.isArray(cart.items) || cart.items.length === 0) return;

      var toRemove = cart.items.filter(function (item) {
        // Puntenwinkel-inwisselingen (_oduree_punten) en welkomstcadeaus
        // (_oduree_wcg, Sample bij Duo/Quattro) mogen blijven: de opruimer is
        // alleen bedoeld voor losse sample-koop buiten de Discovery Set om.
        if (item && item.properties && (item.properties._oduree_punten || item.properties._oduree_wcg)) return false;
        // Kraskaartcadeau (Alia, code SAMPLE): gratis sample via
        // assets/oduree-kraskaart-cadeaus.js, ook laten staan.
        if (item && item.properties && item.properties._oduree_kraskaart_sample === "true") return false;
        return (
          item &&
          APS5_SAMPLE_VARIANT_IDS.indexOf(String(item.variant_id)) >= 0
        );
      });
      if (toRemove.length === 0) return;

      for (var idx = 0; idx < toRemove.length; idx++) {
        await fetch("/cart/change.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ id: toRemove[idx].key, quantity: 0 }),
        });
      }

      document.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true }));
      document.dispatchEvent(new CustomEvent("cart:update", { bubbles: true }));
    } catch (err) {
      if (window.console && console.warn) {
        console.warn("[Oduree] standalone APS5 cleanup failed:", err);
      }
    } finally {
      cleanupInProgress = false;
    }
  }

  cleanupStandaloneAps5Lines();
  document.addEventListener("cart:refresh", cleanupStandaloneAps5Lines);
  document.addEventListener("cart:update", cleanupStandaloneAps5Lines);
})();

/* === ODUREE ADD-TO-CART (inline onclick handler voor oduree-product-card) ===
   Gebruikt door snippets/oduree-product-card.liquid via:
     onclick="odureeAddToCart('{{ variant.id }}', this)"
   Moet globaal beschikbaar zijn — eerder stond dit alleen in
   sections/oduree-collection.liquid, waardoor de + knoppen op de
   related-products sectie van productpagina's (oduree-related.liquid)
   een ReferenceError gaven en niets aan de winkelwagen toevoegden.
   Guarded zodat de collection-section definitie niet overschreven wordt. */
(function () {
  window.odureeAddToCart = async function (variantId, btn) {
    var icon = btn.querySelector(".oduree-prod-card__add-icon");
    if (!icon) return;
    var original = icon.textContent;
    icon.textContent = "\u2026";
    btn.disabled = true;
    try {
      var res = await fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({ id: variantId, quantity: 1 }),
      });
      if (!res.ok) throw new Error("cart add failed");
      icon.textContent = "\u2713";
      btn.classList.add("is-added");
      document.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true }));
      document.dispatchEvent(new CustomEvent("cart:update", { bubbles: true }));
      document.dispatchEvent(new CustomEvent("cart:open", { bubbles: true }));
    } catch (e) {
      icon.textContent = "!";
    } finally {
      setTimeout(function () {
        icon.textContent = original || "+";
        btn.classList.remove("is-added");
        btn.disabled = false;
      }, 1500);
    }
  };
})();


/* === ODUREE CART TIMER ===
   Afteltimer in de cart-drawer (sectie-instelling timer_enabled). Per sessie:
   de deadline start zodra een drawer met inhoud in de DOM staat en blijft
   staan over re-renders van de drawer heen (sessionStorage). Bij een lege
   winkelwagen vervalt de deadline, zodat een volgende sessie opnieuw start. */
(function () {
  "use strict";
  var KEY = "oduree_cart_timer_deadline";
  var lees = function () { try { return Number(sessionStorage.getItem(KEY)) || 0; } catch (_) { return 0; } };
  var schrijf = function (v) { try { if (v) sessionStorage.setItem(KEY, String(v)); else sessionStorage.removeItem(KEY); } catch (_) {} };
  var pad = function (n) { return (n < 10 ? "0" : "") + n; };
  function tik() {
    var el = document.querySelector("[data-cart-timer]");
    if (!el) {
      // Drawer zonder timer (lege cart): deadline loslaten.
      if (document.querySelector("[data-cart-drawer]") && !document.querySelector("[data-cart-item]")) schrijf(0);
      return;
    }
    var minuten = parseInt(el.getAttribute("data-minutes"), 10) || 10;
    var deadline = lees();
    if (!deadline) { deadline = Date.now() + minuten * 60000; schrijf(deadline); }
    var rest = Math.max(0, deadline - Date.now());
    var txt = el.querySelector("[data-cart-timer-text]") || el;
    if (rest <= 0) {
      el.classList.add("is-expired");
      txt.innerHTML = el.getAttribute("data-expired-text") || "";
    } else {
      el.classList.remove("is-expired");
      var m = Math.floor(rest / 60000), sec = Math.floor((rest % 60000) / 1000);
      txt.innerHTML = (el.getAttribute("data-text") || "[time]").replace("[time]", pad(m) + ":" + pad(sec));
    }
  }
  tik();
  setInterval(tik, 1000);
  // Na een her-render van de drawer (cart:updated) meteen vullen, anders staat
  // de balk tot de volgende seconde-tik leeg en springt de lijst.
  document.addEventListener("cart:updated", tik);
  window.OdureeCartTimer = { tik: tik };
})();
